export default {
  label: "Gestión de Usuarios",
  tenantOverview: "Resumen de Organizaciones",
  userAuthorization: "Gestión de Usuarios",
  tabs: {
    pendingUserRequests: "Solicitudes de Usuario Pendientes",
    userAndRolesAssignment: "Asignación de Usuarios y Roles",
  },
  assignRolesToUser: {
    label: "Asignación de Roles a Usuario",
  },
  inviteUsers: {
    label: "Invitar Usuarios",
    formFields: {
      firstName: "Nombre",
      lastName: "Apellido",
      emailAdress: "Dirección de Correo Electrónico",
      successMessage: "Invitación enviada con éxito",
      failedMessage: "Error al enviar la invitación",
    },
  },
  userRoleManager: {
    inviteUser: "Invitar Usuario",
    label: "Gestor de Roles de Usuario",
    roleName: "Nombre del Rol",
    selectRole: "Seleccionar Rol",
    assignedTo: "Asignado a",
    noUsersAssignedMessage: "Aún no hay usuarios asignados a este rol.",
    permissions: "Permisos",
    createdUserRole: "Tu rol de usuario ha sido creado exitosamente.",
    useRoleCreate: "Rol de usuario creado",
    discardChanges: "Descartar cambios",
    discardMessage:
      "Has realizado cambios que no están guardados. ¿Estás seguro de que quieres salir de esta página y dejar esos cambios sin guardar?",
  },
  button: {
    create: {
      role: "Nuevo rol",
    },
  },
  form: {
    label: {
      role: "Editar Rol",
      allUsers: "Todos los Usuarios",
      user: "Editar Usuario",
      deleteUserRole: "Eliminar rol de usuario",
      benutzerApprove: "Aprobar usuario",
      benutzerDeny: "Denegar usuario",
      editRole: "Editar rol",
      tenantDeletionFailed: "Falló la eliminación del organización",
      tenantDeleteSuccess: "Organización eliminado exitosamente",
      checkTenantRole: "Verificar Rol del Organización",
      deleteTenant: "Eliminar Organización",
    },
    message: {
      continueDeleteMessage: "¿Estás seguro de que quieres continuar?",
      approveMessage: "¿Estás seguro de que quieres aprobar al usuario?",
      denyMessage: "¿Estás seguro de que quieres denegar al usuario?",
      userRoleDeleteMessagePt1: "Este rol de usuario está actualmente asignado a",
      userRoleDeleteMessagePt2: "Ya no tendrán acceso a ciertas áreas de la aplicación.",
      userErrorMessage: "el nombre para mostrar no debe estar vacío.",
      userNameErrorMessage: "El nombre de usuario no debe estar vacío.",
      userLastNameErrorMessage: "El apellido del usuario no debe estar vacío.",
      phoneNumerErrorMessage: "El valor ingresado debe ser un número de teléfono.",
      streetAndNumberErrorMessage:
        "Por favor ingresa el nombre de la calle seguido de una coma y el número de la casa (ej. Calle Principal, 123).",
      postalCodeErrorMessage:
        "Por favor ingresa un código postal válido. En Alemania, el código postal consiste en cinco dígitos.",
      requiredInformation: "Esta información es requerida.",
      tenantNameExists: "El nombre del Organización ya existe, por favor ingresa otro nombre.",
      userBlockMessage: "¿Estás seguro de que quieres bloquear a este usuario?",
      userUnblockMessage: "¿Estás seguro de que quieres desbloquear a este usuario?",
      deleteTenantNotPossible: "El organización no debe ser eliminado ya que aún quedan usuarios asignados",
      deleteTenantSuccess: "El organización anterior fue eliminado exitosamente.",
      tenantCanBeDeleted: ({ tenantName }: { tenantName: string | undefined }) =>
        `Ya no hay usuarios asociados con la organización${
          tenantName && ` "${tenantName}"`
        }. ¿Quieres eliminar esta organización de la base de datos?`,
      tenantCanNotBeDeleted: ({ tenantName }: { tenantName: string | undefined }) =>
        `La organización ${
          tenantName && `"${tenantName}" `
        }no puede ser eliminada actualmente porque otros usuarios están actualmente asignados a esta organización. Previamente, asigna todos los usuarios restantes a una nueva organización para poder eliminar ${
          tenantName ? `"${tenantName}"` : "la misma"
        } de la base de datos.`,
      checkTenantRole: ({
        currentTenantRole,
        newTenantRole,
      }: {
        currentTenantRole: string | undefined;
        newTenantRole: string | undefined;
      }) =>
        `<p>El rol actual del usuario no se alinea con el rol predeterminado del organización seleccionado. Ten en cuenta que los siguientes cambios se ejecutarán si continúas:</p>
        <ul>
          <li>Eliminación de asignaciones de rol existentes: ${
            currentTenantRole ? `"${currentTenantRole}".` : "Ninguno"
          }</li>
          <li>Nueva asignación de rol: ${newTenantRole ? `"${newTenantRole}".` : "Ninguno"}</li>
        </ul>
        <p>¿Deseas continuar?</p>`,
    },
    edit: {
      tabLabel: {
        editRole: "Cambiar Rol",
        assignScope: "Asignar Permisos",
        assignUser: "Asignar Usuarios",
      },
      listLabel: {
        assigned: "Asignado",
        unassigned: "No asignado",
      },
    },
  },
  table: {
    column: {
      description: "Descripción",
      email: "Correo Electrónico",
      firstName: "Nombre",
      lastName: "Apellido",
      name: "Nombre",
      role: "Roles del Usuario",
      tenant: "Organización / Empresa",
      value: "Valor",
      userRole: "Nombre del rol de usuario",
      roleDescription: "Descripción del rol",
      pendingRequestsAction: "Acción",
    },
  },
};
